module.exports = {
  log: function (message, context) {
    if (this.enabled) {
      console.log('tuner:' + message, context || ''); // eslint-disable-line no-console
    }
  },
};